import React                 from "react";
import FormController        from "@app/controllers/dashboard/form";

const FormCartController = (props) =>
    <FormController {...props}
                    backLocationOut={true}
    />

export default FormCartController;
